
(function () {
  'use strict';

  if (document.documentElement.getAttribute('data-lsbh-measurement-v2') === '1') return;
  document.documentElement.setAttribute('data-lsbh-measurement-v2', '1');

  var controller = window.LSBHMeasurement;
  if (!controller || controller.version !== '2.0.0-preview-safe') return;

  var currentScript = document.currentScript;
  var requestedFamily = currentScript && currentScript.getAttribute
    ? currentScript.getAttribute('data-page-family')
    : '';
  var PAGE_FAMILIES = {
    home: true,
    sydney_hub: true,
    regional_hub: true,
    local_area: true,
    book: true,
    other: true
  };
  var pageFamily = PAGE_FAMILIES[requestedFamily] ? requestedFamily : 'other';
  var INPUT_KINDS = { postcode: true, suburb: true };
  var ERROR_CODES = {
    location_required: true,
    location_unresolved: true,
    postcode_invalid: true
  };
  var AVAILABILITY = {
    available: true,
    unavailable: true,
    service_error: true,
    unknown: true
  };
  var recent = Object.create(null);
  var startedForms = typeof WeakSet === 'function' ? new WeakSet() : null;
  var seenActions = typeof WeakMap === 'function' ? new WeakMap() : null;
  var quarantineCount = 0;
  var pageViewSent = false;

  function hasOwn(value, key) {
    return Object.prototype.hasOwnProperty.call(value, key);
  }

  function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
  }

  function enumValue(table, value) {
    return typeof value === 'string' && hasOwn(table, value) ? value : '';
  }

  function cleanPageLocation() {
    try {
      var origin = String(window.location.origin || '');
      var path = String(window.location.pathname || '/');
      if (!/^https?:\/\/[^/?#]+$/i.test(origin)) return '';
      if (!/^\//.test(path)) path = '/' + path;
      return origin + path.replace(/[?#].*$/, '');
    } catch (error) {
      return '';
    }
  }

  function cleanReferrer() {
    try {
      if (!document.referrer) return '';
      var parsed = new URL(document.referrer);
      if (!/^https?:$/.test(parsed.protocol)) return '';
      return parsed.origin;
    } catch (error) {
      return '';
    }
  }

  function build(name, input) {
    var value = isPlainObject(input) ? input : {};
    var output;
    if (name === 'page_view') {
      output = { page_family: pageFamily };
    } else if (name === 'quote_start') {
      output = { page_family: pageFamily, form_id: 'canonical_quote' };
    } else if (name === 'search') {
      var inputKind = enumValue(INPUT_KINDS, value.location_input_kind);
      if (!inputKind) return null;
      output = {
        search_term: 'service_area',
        page_family: pageFamily,
        form_id: 'canonical_quote',
        location_input_kind: inputKind
      };
    } else if (name === 'location_validated') {
      var validatedKind = enumValue(INPUT_KINDS, value.location_input_kind);
      var availability = enumValue(AVAILABILITY, value.availability_result);
      if (!validatedKind || !availability) return null;
      output = {
        page_family: pageFamily,
        form_id: 'canonical_quote',
        location_input_kind: validatedKind,
        availability_result: availability
      };
    } else if (name === 'quote_validation_error') {
      var errorCode = enumValue(ERROR_CODES, value.generic_error_code);
      if (!errorCode) return null;
      output = {
        page_family: pageFamily,
        form_id: 'canonical_quote',
        generic_error_code: errorCode
      };
    } else if (name === 'contact_click') {
      var channel = value.contact_channel === 'phone' || value.contact_channel === 'sms'
        ? value.contact_channel
        : '';
      if (!channel) return null;
      output = { page_family: pageFamily, contact_channel: channel };
    } else {
      return null;
    }
    var pageLocation = cleanPageLocation();
    var referrer = cleanReferrer();
    if (pageLocation) output.page_location = pageLocation;
    if (referrer) output.page_referrer = referrer;
    return output;
  }

  function stableKey(name, payload) {
    var keys = Object.keys(payload).sort();
    var parts = [name];
    for (var i = 0; i < keys.length; i += 1) parts.push(keys[i] + '=' + String(payload[keys[i]]));
    return parts.join('|');
  }

  function alreadySeenAction(action, name) {
    if (!action || !seenActions || (typeof action !== 'object' && typeof action !== 'function')) return false;
    var names = seenActions.get(action);
    if (!names) {
      names = Object.create(null);
      seenActions.set(action, names);
    }
    if (names[name]) return true;
    names[name] = true;
    return false;
  }

  function emit(name, input, action) {
    if (!controller.analyticsAllowed()) return false;
    var payload = build(name, input);
    if (!payload) return false;
    if (action) {
      if (alreadySeenAction(action, name)) return false;
    } else {
      var key = stableKey(name, payload);
      var now = Date.now();
      if (recent[key] && now - recent[key] < 1500) return false;
      recent[key] = now;
    }
    window.gtag('event', name, payload);
    return true;
  }

  function ingestLegacy(value) {
    // The only legacy bridge retained is the Wave C enum-only location event.
    // Any legacy event containing raw search text is discarded, not replayed.
    if (value.event !== 'lsbh_location_search' || hasOwn(value, 'search_location')) return;
    var inputKind = enumValue(INPUT_KINDS, value.search_location_type);
    if (!inputKind) return;
    emit('search', { location_input_kind: inputKind });
  }

  function quarantinePlainObject(value) {
    quarantineCount += 1;
    ingestLegacy(value);
  }

  var dataLayer = window.dataLayer = window.dataLayer || [];
  var originalPush = dataLayer.push;
  var retained = [];
  for (var queuedIndex = 0; queuedIndex < dataLayer.length; queuedIndex += 1) {
    if (isPlainObject(dataLayer[queuedIndex])) quarantinePlainObject(dataLayer[queuedIndex]);
    else retained.push(dataLayer[queuedIndex]);
  }
  dataLayer.length = 0;
  originalPush.apply(dataLayer, retained);
  dataLayer.push = function () {
    var result = dataLayer.length;
    for (var index = 0; index < arguments.length; index += 1) {
      if (isPlainObject(arguments[index])) quarantinePlainObject(arguments[index]);
      else result = originalPush.call(dataLayer, arguments[index]);
    }
    return result;
  };

  function closest(element, selector) {
    try {
      return element && element.closest ? element.closest(selector) : null;
    } catch (error) {
      return null;
    }
  }

  function quoteInteraction(event) {
    var form = closest(event.target, '#lsbh-p1-form');
    if (!form || (startedForms && startedForms.has(form))) return;
    if (emit('quote_start', {}, event) && startedForms) startedForms.add(form);
  }

  document.addEventListener('pointerdown', quoteInteraction, true);
  document.addEventListener('focusin', quoteInteraction, true);
  document.addEventListener('click', function (event) {
    if (closest(event.target, 'a[href^="tel:"]')) {
      emit('contact_click', { contact_channel: 'phone' }, event);
      return;
    }
    if (closest(event.target, 'a[href^="sms:"]')) {
      emit('contact_click', { contact_channel: 'sms' }, event);
    }
  }, true);

  window.LSBHMeasure = Object.freeze({
    version: '2.0.0-preview-safe',
    dispatch: function (name, input) { return emit(name, input); },
    status: function () {
      return {
        pageFamily: pageFamily,
        quarantinedPlainObjects: quarantineCount,
        analyticsAllowed: controller.analyticsAllowed()
      };
    }
  });

  controller.onAnalyticsReady(function () {
    if (pageViewSent) return;
    if (emit('page_view', {})) pageViewSent = true;
  });
}());
